import { Box, Skeleton } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { FieldView, Txt } from '@app/components/common';
import { UserInfo } from '@app/api/models';
import { useApi } from '@app/hooks';

export const UserInfoBlock = ({ username, date }: { username: string, date: string }) => {  
  const [user, setUser] = useState<UserInfo>();
  const [isLoading, setIsLoading] = useState(false);
  const api = useApi();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await api.users.getUsers({ filter: { username }, limit: 1, offset: 0, sort: '+id' });
      if (response.code === 200) {  
        const data = response.data?.data;
        setUser({
          username: data?.[0].username,
          full_name: data?.[0].first_name + ' ' + data?.[0].last_name,
          email: data?.[0].email,
          phone: data?.[0].phone,
        });
      }
      setIsLoading(false);
    })();
  }, [username]);

  if (!isLoading && !user) {
    return <Box minH={120}>
      <Skeleton variant="rect" width="100%" height="120px" />
    </Box>;
  }

  return <>
    <Box display='flex' justifyContent='space-between' mt={0} pb={0} alignItems='center'>
      <Txt color='gray.500'>{date}</Txt>
      <Txt>{user?.full_name} [{user?.username}]</Txt>
    </Box>
    <Box mt={2} pb={4}>
      <FieldView title='Email' value={user?.email} canCopy direction='row' fullWidth />
      <FieldView title='Телефон' value={user?.phone} canCopy direction='row' fullWidth />
    </Box>
  </>;
};